import React, { useEffect } from "react";
import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Marquee from "../components/landing/Marquee";
import Problem from "../components/landing/Problem";
import Platform from "../components/landing/Platform";
import Features from "../components/landing/Features";
import Benefits from "../components/landing/Benefits";
import Audience from "../components/landing/Audience";
import AppPreview from "../components/landing/AppPreview";
import Event from "../components/landing/Event";
import Program from "../components/landing/Program";
import RegistrationForm from "../components/landing/RegistrationForm";
import FAQ from "../components/landing/FAQ";
import Footer from "../components/landing/Footer";
import { useLenis } from "../hooks/useLenis";
import { logAnalytics } from "../lib/api";

export default function LandingPage() {
    useLenis();

    useEffect(() => {
        logAnalytics("landing_view", {}, "/");
        // Ensure browsers don't auto-translate: force Italian lang + notranslate on <html>
        document.documentElement.lang = "it";
        document.documentElement.setAttribute("translate", "no");
        document.documentElement.classList.add("notranslate");
        // SEO meta — focus keyword: software gestionale sicurezza sul lavoro
        document.title = "SafetyDesk81 | Software gestionale per la sicurezza sul lavoro con AI";
        const setMeta = (name, content, attr = "name") => {
            let el = document.head.querySelector(`meta[${attr}="${name}"]`);
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute(attr, name);
                document.head.appendChild(el);
            }
            el.setAttribute("content", content);
        };
        setMeta(
            "description",
            "SafetyDesk81 è il software gestionale per la sicurezza sul lavoro con intelligenza artificiale, registri digitali HSE e formazione alimentaristi. Iscriviti alla presentazione ufficiale del 1° ottobre 2026 a Montepulciano."
        );
        setMeta(
            "keywords",
            "software sicurezza sul lavoro, gestionale sicurezza sul lavoro, software HSE, intelligenza artificiale sicurezza sul lavoro, formazione alimentaristi, SafetyDesk81, Centro Sicurezza Consulenze"
        );
        setMeta("og:title", "SafetyDesk81 · Software gestionale sicurezza sul lavoro con AI", "property");
        setMeta(
            "og:description",
            "Software HSE con intelligenza artificiale, registri digitali e formazione alimentaristi. Presentazione ufficiale il 1° ottobre 2026 a Montepulciano.",
            "property"
        );
        setMeta("og:type", "website", "property");
        setMeta("twitter:card", "summary_large_image");
    }, []);

    return (
        <div data-testid="landing-page" className="relative">
            <Header />
            <main>
                {/* Focus: evento del 1 ottobre 2026 immediatamente visibile */}
                <Hero />
                <Event />
                <Program />
                <RegistrationForm />

                {/* Approfondimento software SafetyDesk81 */}
                <Marquee />
                <Problem />
                <Platform />
                <Features />
                <Benefits />
                <Audience />
                <AppPreview />
                <FAQ />
            </main>
            <Footer />
        </div>
    );
}
